/**
 * Receveur
 */
import CustomObject from '../CustomObject.js'

export default class ShowerTray extends CustomObject
{
    constructor(modelPath, position, id, scale, pn, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "showerTray";
        this.scale = scale;
        this.collisionAllowed = false;
        this.snappingAllowed = false;
        this.axesMove = [true, false, true]; // x, y
        this.pn = pn; // number
        
    }
}

/**
 * Un receveur a 3 tailles
 * On peut réduire sa taille jusqu'à la prochaine taille en dessous
 * //!!\\ Savoir quelles sont les 3 tailles fixes 
 */